import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Intake, Patient } from '../models';
import { Api, Session } from '../services/index';
import { MyModal } from '../components/modal/modal';


@Component({
  selector: 'app-dashboard-our-providers',
  templateUrl: './dashboard-our-providers.html'
})



export class DashboardOurProviders {
  providerSpecialtyType = this.route.snapshot.params['type'] || '1';
  isValidProfile: boolean = false;
  loading = false;
  medicalExamType: string;
  patient: Patient;

  @ViewChild('myBHNotice') public _modalBHNotice: MyModal;
  @ViewChild('myIncompleteProfile') public _modalIncompleteProfile: MyModal;
  constructor(private router: Router,
    private route: ActivatedRoute,
    public session: Session,
    public api: Api) {
    let getPatient = this.api.getMember(this.session.patientId).subscribe(patient => {
      this.patient = patient;
    })
  }



  requestExam() {
    if (this.validatePatientProfile(this.patient)) {

      switch (this.providerSpecialtyType) {
        case '1':
          this.session.intakeLob = 'UC';
          this.router.navigate(['/exam-request-care-today']);
          break;
        case '2': //Therapy
          this.session.intakeLob = 'BH';
          this.session.intakeBhType = 'THI';
          this._modalBHNotice.open();
          break;
        case '3': //Psychiatry
          this.session.intakeLob = 'BH';
          this.session.intakeBhType = 'PSI';
          this._modalBHNotice.open();
          break;
      }


    } else {
      this.router.navigate(['/dashboard-my-profile']);
    }
  }

  validatePatientProfile(patient): boolean {
    let isValidProfile: boolean = true;
    if (!patient.profile.address1) {
      isValidProfile = false;
    }
    if (!patient.profile.city) {
      isValidProfile = false;
    }
    if (!patient.profile.dateOfBirth) {
      isValidProfile = false;
    }
    if (!patient.profile.firstName) {
      isValidProfile = false;
    }
    if (!patient.profile.lastName) {
      isValidProfile = false;
    }
    if (!patient.profile.gender) {
      isValidProfile = false;
    }
    if (!patient.profile.state) {
      isValidProfile = false;
    }
    if (!patient.profile.zipCode) {
      isValidProfile = false;
    }
    if (!patient.phoneNumber) {
      isValidProfile = false;
    }
    if (!patient.email) {
      isValidProfile = false;
    }

    return isValidProfile;
  }
	loadExamRequestCareToday() {
		this.session.intakeLob = 'BH';
		if(this.providerSpecialtyType === '2'){
			this.session.intakeBhType = 'THI';
		}else if(this.providerSpecialtyType === '3'){
			this.session.intakeBhType = 'PSI';
		}
		
		this._modalBHNotice.close();
		this.router.navigate(['/exam-request-care-today']);
	}
  // requestExam(){
  // 	this.router.navigateByUrl('/exam-request-care-today');
  // }

  // gotoDashboard() {
  //   this.router.navigate(['/dashboard']);
  // }
  gotoDashboard() {

    this.router.navigate(['/dashboard']);
  }

  gotoProfile(nav: boolean){
    if(nav){
      this.router.navigate(['/dashboard/dashboard-my-profile']);
    }else{
      this.router.navigate(['/dashboard']);
    }
  }
}